import React, { useEffect, useState, useContext, useRef } from 'react';
import Select from 'react-select';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';

/** Mobx state store */
import { observer } from 'mobx-react';
import BookingStoreContext from '../../../stores/bookingStore';

/** Core utils */
import { getBookings, getUsers, getVehicles } from './service';

// core components
import RowBooking from './RowBooking';
// import BookingFilters from './BookingFilters';
const loggedUser = localStorage.currentUser ? JSON.parse(localStorage.currentUser) : null;

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  paper: {
    marginTop: theme.spacing(3),
    width: '100%',
    overflowX: 'auto',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 650,
  },
  header: {
    textTransform: 'uppercase',
  },
}));

function ListBookings({ showStatus, showOptions, requested }) {
  const classes = useStyles();
  const bookingStore = useContext(BookingStoreContext);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [bookings, setBookings] = useState({
    isLoading: true,
    list: [],
    totalCount: 0,
    nextPage: null,
    prevPages: null,
    totalPages: 0,
  });

  const [status, setStatus] = useState({ value: 'all', label: 'Todas' });

  const loadUsers = async () => {
    const response = await getUsers();

    if (response.status === 200) {
      const driverList = response.data
        .filter(user => user.role === 'driver')
        .map(row => {
          return {
            value: row.id,
            label: row.full_name,
          };
        });

      bookingStore.setValue('drivers', driverList);
    }
  };

  const loadVehicles = async () => {
    const response = await getVehicles();

    if (response && response.status === 200) {
      const allVehicles = response.data;
      const availableVehicles = allVehicles
        .filter(car => car.status === 'available')
        .map(car => {
          return {
            value: car.id,
            label: `[${car.license_plate}] - ${car.vehicle_type}`,
          };
        });

      bookingStore.setValue('allVehicles', allVehicles);
      bookingStore.setValue('vehicles', availableVehicles);
    }
  };

  async function getBookingsByStatus(status, page, rowsPerPage) {
    setBookings({
      ...bookings,
      isLoading: true,
    });
    let selectedStatus = status === "all" ? null : status;
    if (requested) {
      selectedStatus = 'requested';
    }
    const response = await getBookings({ status: selectedStatus, page: page + 1, rowsPerPage });

    if (response && response.status === 200) {
      const list = response.data.bookings;
      bookingStore.setValue('bookings', response.data.bookings);

      setBookings({
        ...bookings,
        isLoading: false,
        list: list.sort((a, b) => (a.id < b.id ? 1 : -1)),
        totalCount: response.data.meta.total_count,
        nextPage: response.data.meta.next_page,
        prevPages: response.data.meta.prev_pages,
        totalPages: response.data.meta.total_pages,
      });
    }
  }

  useEffect(() => {
    if (bookingStore.isLoading) {
      getBookingsByStatus(status.value, page, rowsPerPage);
      if (loggedUser && (loggedUser.role === 'admin' || loggedUser.role === 'programmer')) {
        loadUsers();
        loadVehicles();
      }
      bookingStore.setValue('isLoading', false);
    }

    // if (bookingStore.isLoadingFilter) {
    //   filterVehicles();
    //   bookingStore.setValue('isLoadingFilter', false);
    // }
    // if (vehicleId !== bookingStore.vehicleFilterId) {
    //   // bookingStore.setValue('vehicleFilterId', vehicleFilterId);
    //   filterVehicles();
    // }

    // if (bookingStore.isLoadingFilter) {
    //   let bookingsFilter = bookingStore.bookings;

    //   if (bookingStore.idVehicleFilter !== '') {
    //     bookingsFilter = bookingStore.bookings.filter(item => {
    //       if (item.service && item.service.vehicle_id === bookingStore.idVehicleFilter) {
    //         return item;
    //       }
    //     });
    //   }

    //   setBookings({
    //     ...bookings,
    //     list: bookingsFilter.sort((a, b) => (a.id < b.id ? 1 : -1)),
    //   });
    //   bookingStore.setValue('isLoadingFilter', false);
    // }
  }, []);

  const handleSelectsChange = event => {
    setPage(0);
    setStatus({
      label: event.label,
      value: event.value,
    });
    getBookingsByStatus(event.value, 0, rowsPerPage);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getBookingsByStatus(status.value, newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    getBookingsByStatus(status.value, 0, +event.target.value);
  };

  const statusOptions = [
    { value: 'all', label: 'Todas' },
    { value: 'requested', label: 'Solicitadas' },
    { value: 'approved', label: 'Aprobadas' },
    { value: 'denied', label: 'Denegadas' },
    { value: 'cancelled', label: 'Canceladas' },
    { value: 'completed', label: 'Completadas' },
  ];

  return (
    <>
      <Grid container>
        <Grid item md={10} xs={12}>
          <h4>{requested ? 'Solicitudes pendientes' : 'Solicitudes'}</h4>
        </Grid>
        {!requested && (
          <Grid item md={2} xs={12}>
            <Select
              className="status-filter"
              value={status}
              onChange={e => handleSelectsChange(e)}
              options={statusOptions}
            />
          </Grid>
        )}
      </Grid>
      <Grid container>
        <Grid item md={12} xs={12}>
          <TableContainer
            className="table-container"
            component={Paper}
            style={{
              maxHeight: 460,
              overflowY: 'auto',
              overflowX: 'hidden',
              border: 0,
              borderRadius: 0,
              boxShadow: 'none',
              boxSizing: 'border-box',
            }}
          >
            <Table className={classes.table} size="small" stickyHeader>
              <TableHead className={classes.header}>
                <TableRow>
                  <TableCell padding="checkbox" />
                  <TableCell align="center">Código</TableCell>
                  <TableCell align="center">Solicitante</TableCell>
                  <TableCell align="center">Fecha de salida</TableCell>
                  <TableCell align="center">Fecha de regreso</TableCell>
                  {showStatus && <TableCell align="center">Estado</TableCell>}
                  {showOptions && <TableCell align="center">Acciones</TableCell>}
                </TableRow>
              </TableHead>
              <TableBody>
                {bookings.isLoading && (
                  <TableRow>
                    <TableCell colSpan={12} align="center" style={{ padding: '40px' }}>
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                )}

                {!bookings.isLoading
                  ? bookings.list.map((row, index) => (
                    <RowBooking
                      key={row.id}
                      index={index}
                      row={row}
                      showStatus={showStatus}
                      showOptions={showOptions}
                    />
                    ))
                  : null}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[10, 20, 30, 50]}
            component="div"
            count={bookings.totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              'aria-label': 'previous page',
            }}
            nextIconButtonProps={{
              'aria-label': 'next page',
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Grid>
      </Grid>
    </>
  );
}

ListBookings.defaultProps = {
  showStatus: true,
  showOptions: true,
  requested: false,
};

export default observer(ListBookings);
